export default __webpack_public_path__ + "static/char-s-52-zh-Hant-85604f6737bd9132ef62025dad521de7.webp";